export default __webpack_public_path__ + "static/media/sales.54c4ab8f.svg";